import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";

import { MatxTheme } from "./components";
// ALL CONTEXTS
// import { AuthProvider } from "./contexts/Auth0Context";
import { AuthProvider } from "./contexts/JWTAuthContext";
// import { AuthProvider } from "./contexts/FirebaseAuthContext";
import SettingsProvider from "./contexts/SettingsContext";
// ROUTES
import routes from "./routes";
import { UserDetailsProvider } from "./contexts/UserContext";
// FAKE SERVER
// import "../fake-db";


export default function App() {
  const content = useRoutes(routes);

  return (
    <SettingsProvider>
      <AuthProvider>
        <UserDetailsProvider>
        <MatxTheme>
          <CssBaseline />
          {content}
        </MatxTheme>
        </UserDetailsProvider>
      </AuthProvider>
    </SettingsProvider>
  );
}
